import {
  NSIPS_REPORT_EDIT_SEARCH,
  NSIPS_REPORT_EDIT_SEARCH_SUCCESS,
  NSIPS_REPORT_EDIT_SEARCH_FAILURE,
  NSIPS_REPORT_EDIT_CLEAR,
  NSIPS_REPORT_EDIT_SAVE,
  NSIPS_REPORT_EDIT_SAVE_SUCCESS,
  NSIPS_REPORT_EDIT_SAVE_FAILURE,
  NSIPS_REPORT_EDIT_ALL_SAVE,
  NSIPS_REPORT_EDIT_ALL_SAVE_SUCCESS,
  NSIPS_REPORT_EDIT_ALL_SAVE_FAILURE,
  NSIPS_REPORT_EDIT_SEARCH_HIST,
  NSIPS_REPORT_EDIT_SEARCH_HIST_SUCCESS,
  NSIPS_REPORT_EDIT_SEARCH_HIST_FAILURE,
  NSIPS_REPORT_EDIT_SEARCH_PHRASE,
  NSIPS_REPORT_EDIT_SEARCH_PHRASE_SUCCESS,
  NSIPS_REPORT_EDIT_SEARCH_PHRASE_FAILURE,
  NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS,
  NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS_SUCCESS,
  NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS_FAILURE,
  NSIPS_REPORT_EDIT_ADD_NEW_REPORT,
  NSIPS_REPORT_EDIT_ADD_NEW_REPORT_SUCCESS,
  NSIPS_REPORT_EDIT_ADD_NEW_REPORT_FAILURE,
  NSIPS_REPORT_EDIT_PRINT,
  NSIPS_REPORT_EDIT_PRINT_SUCCESS,
  NSIPS_REPORT_EDIT_PRINT_FAILURE,
  NSIPS_REPORT_EDIT_PRINT_DEL,
  NSIPS_REPORT_EDIT_PRINT_DEL_SUCCESS,
  NSIPS_REPORT_EDIT_PRINT_DEL_FAILURE,
  NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO,
  NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO_SUCCESS,
  NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO_FAILURE,
  NSIPS_REPORT_EDIT_CLINIC_SEND_INFO,
  NSIPS_REPORT_EDIT_CLINIC_SEND_INFO_SUCCESS,
  NSIPS_REPORT_EDIT_CLINIC_SEND_INFO_FAILURE,
  NSIPS_REPORT_EDIT_REPORT_DELETE_NEW_REPORT,
  NSIPS_REPORT_EDIT_MSG_ALERT,
  NSIPS_SEARCH,
  NSIPS_SEARCH_SUCCESS,
  NSIPS_SEARCH_FAILURE,
  NSIPS_DELIVERY_DATE,
  NSIPS_DELIVERY_DATE_SUCCESS,
  NSIPS_DELIVERY_DATE_FAILURE,
  NSIPS_PRESCRIPTION_COMPARISON,
  NSIPS_PRESCRIPTION_COMPARISON_SUCCESS,
  NSIPS_PRESCRIPTION_COMPARISON_FAILURE,
  NSIPS_REPORT_EDIT_CLEAR_USAGES
} from './mutation-types'
import constant from '../constant'
var utils = require('../../utils')

export default {
  utils: utils,
  state: {
    reportEditData: null,
    reportEditDataBackup: null,
    reportEditPhrases: null,
    reportEditTotalCount: 0,
    reportEditSelectReportType: null,
    reportEditDataExists: true,
    reportAdminOrPharmacist: false,
    reportEditNotify: null,
    prescriptionsDeliveryDates: null,
    nsipsDate: null,
    prescriptionsDeliveryDate: null
  },
  getters: {
    /** 報告書等のデータ */
    nsipsReportEditData: state => {
      return state.reportEditData
    },
    /** 報告書等のバックアップ */
    nsipsReportEditDataBackup: state => {
      return state.reportEditDataBackup
    },
    /** 報告書カウント */
    nsipsReportEditTotalCount: state => {
      return state.reportEditTotalCount
    },
    /** 定型文 */
    nsipsReportEditPhrases: state => {
      return state.reportEditPhrases
    },
    /** セレクトボックス */
    nsipsReportEditSelectReportType: state => {
      return state.reportEditSelectReportType
    },
    /** 検索パラメーター */
    nsipsReportEditSearchParams: state => {
      return state.searchParams
    },
    /** 検索後のデータありなし */
    nsipsReportEditDataExists: state => {
      return state.reportEditDataExists
    },
    /** システム管理者 または 薬剤師確認 */
    nsipsReportAdminOrPharmacist: state => {
      return state.reportAdminOrPharmacist
    },
    /** 通知 */
    nsipsReportEditNotify: state => {
      return state.reportEditNotify
    },
    prescriptionsDeliveryDates: state => {
      return state.prescriptionsDeliveryDates
    },
    prescriptionsDeliveryDate: state => {
      return state.prescriptionsDeliveryDate
    },
    nsipsDate: state => {
      return state.nsipsDate
    }
  },
  actions: {
    /** 報告書検索 */
    [NSIPS_REPORT_EDIT_SEARCH] ({dispatch, state, commit}, params) {
      console.log('NSIPS_REPORT_EDIT_SEARCH')
      var url = '/nsips/reports_edit'
      var data = {}
      var callback = params.callback
      if (params) {
        state.searchParams = params.data
        data = params.data
      }

      state.reportEditDataExists = true // データあり状態で「データが見つかりませんでした」表示を制御
      state.reportEditData = null
      state.reportEditDataBackup = null
      state.reportAdminOrPharmacist = false

      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_REPORT_EDIT_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NSIPS_REPORT_EDIT_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    /** クリア */
    [NSIPS_REPORT_EDIT_CLEAR] ({state, commit}, patientIndex) {
      console.log('NSIPS_REPORT_EDIT_CLEAR')
      commit(NSIPS_REPORT_EDIT_CLEAR, patientIndex)
    },
    /** 報告書保存 */
    [NSIPS_REPORT_EDIT_SAVE] ({dispatch, state, commit}, params) {
      console.log('NSIPS_REPORT_EDIT_SAVE')
      var url = '/nsips/reports_edit/save'
      var data = params.data
      var callback = params.callback
      var patientIndex = params.patient_index
      dispatch('apiPost', {url: url, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_REPORT_EDIT_SAVE_FAILURE, res.data)
          } else {
            commit(NSIPS_REPORT_EDIT_SAVE_SUCCESS, {data: res.data, callback: callback, patient_index: patientIndex})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    /** 報告書全て保存 */
    [NSIPS_REPORT_EDIT_ALL_SAVE] ({dispatch, state, commit}, params) {
      console.log('NSIPS_REPORT_EDIT_ALL_SAVE')
      var url = '/nsips/reports_edit/all_save'
      var data = params.data
      var callback = params.callback
      var patientIndex = params.patient_index
      dispatch('apiPost', {url: url, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_REPORT_EDIT_ALL_SAVE_FAILURE, res.data)
          } else {
            commit(NSIPS_REPORT_EDIT_ALL_SAVE_SUCCESS, {data: res.data, callback: callback, patient_index: patientIndex})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },

    /** 報告書履歴検索 */
    [NSIPS_REPORT_EDIT_SEARCH_HIST] ({dispatch, state, commit}, params) {
      console.log('NSIPS_REPORT_EDIT_SEARCH_HIST')
      var url = '/nsips/reports_edit/hist'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_REPORT_EDIT_SEARCH_HIST_FAILURE, res.data)
          } else {
            commit(NSIPS_REPORT_EDIT_SEARCH_HIST_SUCCESS, {data: res.data})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },

    /** 定型文検索 */
    [NSIPS_REPORT_EDIT_SEARCH_PHRASE] ({dispatch, state, commit}, params) {
      console.log('NSIPS_REPORT_EDIT_SEARCH_PHRASE')
      var url = '/phrases'
      var data = {}
      var callback = null
      if (params) {
        data = params.data
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_REPORT_EDIT_SEARCH_PHRASE_FAILURE, res.data)
          } else {
            commit(NSIPS_REPORT_EDIT_SEARCH_PHRASE_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },

    /** 報告書追加作成 */
    [NSIPS_REPORT_EDIT_ADD_NEW_REPORT] ({dispatch, state, commit}, params) {
      console.log('NSIPS_REPORT_EDIT_ADD_NEW_REPORT')
      var url = '/nsips/reports_edit/get_last_report'
      var data = params.data
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_REPORT_EDIT_ADD_NEW_REPORT_FAILURE, res.data)
          } else {
            commit(NSIPS_REPORT_EDIT_ADD_NEW_REPORT_SUCCESS, {data: res.data, params: params})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },

    /** 報告書印刷 */
    [NSIPS_REPORT_EDIT_PRINT] ({dispatch, state, commit}, params) {
      console.log('NSIPS_REPORT_PRINT_REPORT')
      var url = '/nsips/reports_edit/print'
      var data = params.data
      var callback = params.callback
      var win = params.win
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_REPORT_EDIT_PRINT_FAILURE, {data: res.data, callback: callback, win: win})
          } else {
            commit(NSIPS_REPORT_EDIT_PRINT_SUCCESS, {data: res.data, callback: callback, win: win})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    /** 印刷削除 */
    [NSIPS_REPORT_EDIT_PRINT_DEL] ({dispatch, state, commit}, params) {
      console.log('NSIPS_REPORT_EDIT_PRINT_DEL')
      var url = '/nsips/reports_edit/print_delete'
      var data = params.data
      dispatch('apiGet', {url: url, data: data, loadparams: false})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_REPORT_EDIT_PRINT_DEL_FAILURE, res.data)
          } else {
            commit(NSIPS_REPORT_EDIT_PRINT_DEL_SUCCESS, {data: res.data})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },

    /** 報告書削除 */
    [NSIPS_REPORT_EDIT_REPORT_DELETE_NEW_REPORT] ({state, commit}, params) {
      commit(NSIPS_REPORT_EDIT_REPORT_DELETE_NEW_REPORT, params)
    },

    /** 補助入力 */
    [NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS] ({dispatch, state, commit}, params) {
      console.log('NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS')
      var url = '/nsips/reports_edit/get_auto_consult_points'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS_FAILURE, res.data)
          } else {
            commit(NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS_SUCCESS, {data: res.data})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },

    /** 介護支援事業所情報取得 */
    [NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO] ({dispatch, state, commit}, params) {
      console.log('NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO')
      var url = '/nsips/reports_edit/careoffice_send_info'
      var data = {}
      var callback = () => {}
      if (params) {
        data = params.data
        if (params.callback) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: false})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NSIPS_REPORT_EDIT_CLINIC_SEND_INFO] ({dispatch, state, commit}, params) {
      console.log('NSIPS_REPORT_EDIT_CLINIC_SEND_INFO')
      var url = '/nsips/reports_edit/clinic_send_info'
      var data = {}
      var callback = () => {}
      if (params) {
        data = params.data
        if (params.callback) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: false})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_REPORT_EDIT_CLINIC_SEND_INFO_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NSIPS_REPORT_EDIT_CLINIC_SEND_INFO_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },

    [NSIPS_REPORT_EDIT_MSG_ALERT] ({state, commit}, msg) {
      commit(NSIPS_REPORT_EDIT_MSG_ALERT, msg)
    },

    [NSIPS_SEARCH] ({dispatch, state, commit}, params) {
      console.log('NSIPS_SEARCH')
      var url = '/nsips/reports_edit/get_nsips/' + params.data.patient
      var callback = () => {}
      var loadparams = true
      if (params) {
        if (params.loadparams) {
          loadparams = params.loadparams
        }
        if (params.callback) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NSIPS_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    /** 処方日取得 */
    [NSIPS_DELIVERY_DATE] ({dispatch, state, commit}, params) {
      console.log('NSIPS_DELIVERY_DATE')
      var url = '/nsips/reports_edit/get_delivery_dates'
      var callback = () => {}
      var data = {}
      if (params) {
        data = params.data
        if (params.callback) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_DELIVERY_DATE_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NSIPS_DELIVERY_DATE_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NSIPS_PRESCRIPTION_COMPARISON] ({dispatch, state, commit}, params) {
      console.log('NSIPS_PRESCRIPTION_COMPARISON')
      var url = '/nsips/reports_edit/prescription_comparison'
      var callback = () => {}
      var data = {}
      var loadparams = true
      if (params) {
        data = params.data
        if (params.loadparams) {
          loadparams = params.loadparams
        }
        if (params.callback) {
          callback = params.callback
        }
      }
      dispatch('apiPost', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NSIPS_PRESCRIPTION_COMPARISON_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NSIPS_PRESCRIPTION_COMPARISON_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NSIPS_REPORT_EDIT_CLEAR_USAGES] ({dispatch, state, commit}, params) {
      console.log('NSIPS_REPORT_EDIT_CLEAR_USAGES')
      state.reportEditData[params.index]['ns_usages']['data'] = null
    }
  },
  mutations: {
    /** 報告書検索成功 */
    [NSIPS_REPORT_EDIT_SEARCH_SUCCESS] (state, params) {
      console.log('NSIPS_REPORT_EDIT_SEARCH_SUCCESS')
      var data = params.data

      if ('data' in data && data.data !== null) {
        // 患者 計画書 報告書 データ
        state.reportEditData = data.data
        // 計画書 報告書 データバックアップ
        state.reportEditDataBackup = []
        for (var i = 0; i < data.data.length; i++) {
          if (data.data[i]['report']['require_clinic_send'] === null && data.data[i]['report']['require_careoffice_send'] === null) {
            // 送信先の初期値がない場合は設定
            data.data[i]['report']['require_clinic_send'] = 0
            data.data[i]['report']['require_careoffice_send'] = 0
            if (data.data[i]['report']['report_type'] === constant.report.report_type.kyotaku) {
              data.data[i]['report']['require_clinic_send'] = 1
              data.data[i]['report']['require_careoffice_send'] = 1
            } else if (data.data[i]['report']['report_type'] === constant.report.report_type.yakuzai_kanri) {
              data.data[i]['report']['require_clinic_send'] = 1
            }
          }

          state.reportEditDataBackup.push({
            'plan': Object.assign({}, {}, data.data[i]['plan']),
            'report': Object.assign({}, {}, data.data[i]['report'])
          })
        }
        state.reportEditSelectReportType = utils.setAddKeyValOrHyphen(data['select']['report_type'])
        state.reportAdminOrPharmacist = data['admin_or_pharmacist'] // システム管理者 または 薬剤師確認
        state.reportEditTotalCount = data.meta['total-count']
        state.prescriptionsDeliveryDates = data.prescriptions_delivery_dates
        state.reportEditDataExists = true // データあり
      } else {
        state.reportEditData = null
        state.reportEditDataBackup = null
        state.reportEditDataExists = false // データなし
        state.reportAdminOrPharmacist = false // システム管理者 または 薬剤師確認
      }
      if (params.callback) {
        params.callback()
      }
    },
    /** 報告書検索失敗 */
    [NSIPS_REPORT_EDIT_SEARCH_FAILURE] (state, params) {
      console.log('NSIPS_REPORT_EDIT_SEARCH_FAILURE')
      // 通知
      state.reportEditNotify = {
        danger: true,
        message_i18n: 'messages.search.danger'
      }
      state.reportEditDataExists = false // データなし
      setTimeout(() => {
        state.reportEditNotify = null
      }, constant.notifyShowTime.normal)

      if (params.callback) {
        params.callback()
      }
    },

    /** 保存成功 */
    [NSIPS_REPORT_EDIT_SAVE_SUCCESS] (state, params) {
      console.log('NSIPS_REPORT_EDIT_SAVE_SUCCESS')
      var data = params.data
      var callback = params.callback
      var patientIndex = params.patient_index

      if ('data' in data || data.data !== null) {
        var plan = data.data['plan']
        var report = data.data['report']
        state.reportEditData[patientIndex]['plan'] = plan
        state.reportEditData[patientIndex]['report'] = report
        state.reportEditDataBackup[patientIndex]['plan'] = Object.assign({}, {}, plan)
        state.reportEditDataBackup[patientIndex]['report'] = Object.assign({}, {}, report)
      }

      if (data.data['input_complete'] === false) {
        // 未入力あり
        state.reportEditNotify = {
          danger: true,
          message_i18n: 'messages.save.report_warning'
        }
      } else {
        if (data['type'] === constant.report.batch_type.batch) {
          state.reportEditNotify = {
            success: true,
            message_i18n: 'messages.send.success_report_pauling' // 選択された報告書を定期提出しました。
          }
        } else if (data['type'] === constant.report.batch_type.instance) {
          state.reportEditNotify = {
            success: true,
            message_i18n: 'messages.send.success_report_immediate' // 選択された報告書を即時提出しました。
          }
        } else {
          // 完了
          state.reportEditNotify = {
            success: true,
            message_i18n: 'messages.save.success'
          }
        }
      }

      setTimeout(() => {
        state.reportEditNotify = null
      }, constant.notifyShowTime.normal)

      // コールバック
      callback(false, null)
    },
    /** 保存失敗 */
    [NSIPS_REPORT_EDIT_SAVE_FAILURE] (state, data) {
      console.log('NSIPS_REPORT_EDIT_SAVE_FAILURE')
      // 通知
      state.reportEditNotify = {
        danger: true,
        message_i18n: 'messages.save.danger'
      }
      setTimeout(() => {
        state.reportEditNotify = null
      }, constant.notifyShowTime.normal)
    },

    /** 保存成功 */
    [NSIPS_REPORT_EDIT_ALL_SAVE_SUCCESS] (state, params) {
      console.log('NSIPS_REPORT_EDIT_ALL_SAVE_SUCCESS')
      var data = params.data
      var callback = params.callback
      var patientIndex = params.patient_index

      state.reportEditTotalCount = 0
      if ('data' in data && data.data !== null) {
        state.reportEditTotalCount = data.meta['total-count']

        // 現在の患者選択インデックスが少ない場合
        if ((state.reportEditTotalCount - 1) < patientIndex) {
          patientIndex = state.reportEditTotalCount - 1
          if (patientIndex < 0) {
            patientIndex = 0
          }
          callback(true, patientIndex)
        }

        // 患者 計画書 報告書 データ
        state.reportEditData = data.data

        // NSIPS 処方日
        state.prescriptionsDeliveryDates = data.prescriptions_delivery_dates

        // 計画書 報告書 データバックアップ
        state.reportEditDataBackup = []
        for (var i = 0; i < data.data.length; i++) {
          state.reportEditDataBackup.push({
            'plan': Object.assign({}, {}, data.data[i]['plan']),
            'report': Object.assign({}, {}, data.data[i]['report'])
          })
        }
      } else {
        state.reportEditData = null
        state.reportEditDataBackup = null
      }

      if (data['type'] === constant.report.batch_type.batch) {
        state.reportEditNotify = {
          success: true,
          message_i18n: 'messages.send.success_report_pauling' // 選択された報告書を定期提出しました。
        }
      } else if (data['type'] === constant.report.batch_type.instance) {
        state.reportEditNotify = {
          success: true,
          message_i18n: 'messages.send.success_report_immediate' // 選択された報告書を即時提出しました。
        }
      } else {
        // 保存
        state.reportEditNotify = {
          success: true,
          message_i18n: 'messages.save.report_select_success' // 選択された報告書を保存しました。
        }
      }

      setTimeout(() => {
        state.reportEditNotify = null
      }, constant.notifyShowTime.normal)

      // コールバック
      callback(false, null)
    },

    /** 保存失敗 */
    [NSIPS_REPORT_EDIT_ALL_SAVE_FAILURE] (state, data) {
      console.log('NSIPS_REPORT_EDIT_ALL_SAVE_FAILURE')
      // 通知
      state.reportEditNotify = {
        danger: true,
        message_i18n: 'messages.save.danger'
      }
      setTimeout(() => {
        state.reportEditNotify = null
      }, constant.notifyShowTime.normal)
    },

    /** クリア */
    [NSIPS_REPORT_EDIT_CLEAR] (state, patientIndex) {
      console.log('NSIPS_REPORT_EDIT_CLEAR')
      var editMode = state.reportEditData[patientIndex]['report']['edit_mode']
      var plan = Object.assign({}, {}, state.reportEditDataBackup[patientIndex]['plan'])
      var report = Object.assign({}, {}, state.reportEditDataBackup[patientIndex]['report'])
      state.reportEditData[patientIndex]['plan'] = plan
      state.reportEditData[patientIndex]['report'] = report
      state.reportEditData[patientIndex]['report']['edit_mode'] = editMode
    },

    /** 印刷成功 */
    [NSIPS_REPORT_EDIT_PRINT_SUCCESS] (state, params) {
      console.log('NSIPS_REPORT_EDIT_PRINT_SUCCESS')
      var data = params.data
      var callback = params.callback
      var win = params.win
      // コールバック
      callback(data, win)
    },
    /** 印刷失敗 */
    [NSIPS_REPORT_EDIT_PRINT_FAILURE] (state, params) {
      console.log('NSIPS_REPORT_EDIT_PRINT_FAILURE')
      var data = params.data
      var callback = params.callback
      var win = params.win
      // 通知
      if (data.error === 'not_found') {
        state.reportEditNotify = {
          danger: true,
          message_i18n: 'messages.print.not_found'
        }
      } else {
        state.reportEditNotify = {
          danger: true,
          message_i18n: 'messages.print.danger'
        }
      }
      setTimeout(() => {
        state.reportEditNotify = null
      }, constant.notifyShowTime.normal)
      // コールバック
      callback(data, win)
    },

    /** 印刷削除成功 */
    [NSIPS_REPORT_EDIT_PRINT_DEL_SUCCESS] (state, params) {
      console.log('NSIPS_REPORT_EDIT_PRINT_DEL_SUCCESS')
    },
    /** 印刷削除失敗 */
    [NSIPS_REPORT_EDIT_PRINT_DEL_FAILURE] (state, data) {
      console.log('NSIPS_REPORT_EDIT_PRINT_DEL_FAILURE')
    },

    /** 報告書追加作成 */
    [NSIPS_REPORT_EDIT_ADD_NEW_REPORT_FAILURE] (state, data) {
      console.log('NSIPS_REPORT_EDIT_ADD_NEW_REPORT_FAILURE')
    },
    [NSIPS_REPORT_EDIT_ADD_NEW_REPORT_SUCCESS] (state, params) {
      console.log('NSIPS_REPORT_EDIT_ADD_NEW_REPORT_SUCCESS')
      var param = params.params
      var last = null
      if ('data' in params.data) {
        last = params.data.data
      }
      var data = state.reportEditData[param.patientIndex]
      var newData = {}
      var newDataBackup = {}
      for (var key in data) {
        var temp = null
        if (utils.isType('Object', data[key]) || utils.isType('Array', data[key])) {
          // オブジェクト
          temp = Object.assign({}, {}, data[key])
          if (key === 'report') {
            for (var reportKey in temp) {
              // 患者ID 店舗 施設
              if (reportKey === 'patient_id' || reportKey === 'shop_id' || reportKey === 'facility_id' || reportKey === 'careman_id') {
                continue
              }
              temp[reportKey] = null
              if (reportKey === 'post_status') {
                temp[reportKey] = constant.report.post_status.temp
              }
              if (reportKey === 'report_type') {
                temp[reportKey] = constant.report.report_type.none // - なし
              }
              if (reportKey === 'edit_mode') {
                temp[reportKey] = false
              }
              if (reportKey === 'clinic_send_info' || reportKey === 'careoffice_send_info') {
                temp[reportKey] = {
                  email: null,
                  fax: null,
                  fusezi_flag: null,
                  send_timing: null,
                  send_timing_hour: null,
                  send_type: null,
                  send_type_email: null,
                  send_type_fax: null,
                  send_type_post: null
                }
              }
            }
            temp['other_no'] = param['otherNo']
            if (last !== null) {
              // 最終報告書からコピー
              temp['ac_user_name'] = last['ac_user_name']             // 作成者
              temp['user_name'] = last['user_name']                   // 作成者
              temp['reportor_id'] = last['reportor_id']               // 作成者ID
              // temp['prescribe_change'] = last['prescribe_change']     // 処方内容変更点
              // temp['prescribe_check'] = last['prescribe_check']       // 変更点 定期薬変更あり 定期薬変更無し 臨時処方
              // temp['soap_comment'] = last['soap_comment']             // 服薬指導
              temp['confirm_comment'] = last['confirm_comment']       // 確認事項
              temp['taking_status'] = last['taking_status']           // 服薬状況
              temp['remnant_status'] = last['remnant_status']         // 残薬状況
              temp['condition_change'] = last['condition_change']     // 体調変化
              temp['side_effect_status'] = last['side_effect_status'] // 副作用
              temp['interaction'] = last['interaction']               // 相互作用
              temp['take_interaction'] = last['take_interaction']     // 服用薬と相互作用のある飲食物の摂取
              temp['complication'] = last['complication']             // 他科受診、合併症
              temp['other_dosage'] = last['other_dosage']             // 他科からの投薬
              temp['otc_combination'] = last['otc_combination']       // ＯＴＣの併用
              temp['visit_duty'] = last['visit_duty']                 // 義務照会
              temp['dispense_idea'] = last['dispense_idea']           // 調剤上の工夫
              temp['last_request'] = last['last_request']             // 後発品の希望
              temp['medicine_notebook'] = last['medicine_notebook']   // お薬手帳
            }
            newDataBackup[key] = Object.assign({}, {}, temp)
          } else if (key === 'plan') {
            newDataBackup[key] = Object.assign({}, {}, data[key])
          }
        } else {
          // それ以外
          temp = data[key]
        }
        newData[key] = temp
      }
      state.reportEditData.splice(param.patientIndex + 1, 0, newData)
      state.reportEditDataBackup.splice(param.patientIndex + 1, 0, newDataBackup)
      state.prescriptionsDeliveryDates.splice(param.patientIndex + 1, 0, state.prescriptionsDeliveryDates[param.patientIndex])
      state.reportEditTotalCount += 1
      param.callback()
    },

    /** 履歴検索 */
    [NSIPS_REPORT_EDIT_SEARCH_HIST_FAILURE] (state, data) {
      console.log('NSIPS_REPORT_EDIT_SEARCH_HIST_FAILURE')
      // 通知
      state.reportEditNotify = {
        danger: true,
        message_i18n: 'messages.search.danger'
      }
      setTimeout(() => {
        state.reportEditNotify = null
      }, constant.notifyShowTime.normal)
    },
    /** 履歴検索 */
    [NSIPS_REPORT_EDIT_SEARCH_HIST_SUCCESS] (state, params) {
      console.log('NSIPS_REPORT_EDIT_SEARCH_HIST_SUCCESS')
      var data = params.data
      if ('data' in data && data.data !== null) {
        // 患者 計画書 報告書 データ
        var patientIndex = data.data['patient_index']
        var lastReportId = data.data['last_report_id']
        var reportHist = data.data['report_hist']
        var reportHistCount = data.data['report_hist_count']
        var reportHistNo = data.data['report_hist_no']
        var nsUsagesHist = data.data['ns_usages']
        state.reportEditData[patientIndex]['last_report_id'] = lastReportId
        state.reportEditData[patientIndex]['report_hist'] = reportHist
        state.reportEditData[patientIndex]['report_hist_count'] = reportHistCount
        state.reportEditData[patientIndex]['report_hist_no'] = reportHistNo
        state.reportEditData[patientIndex]['report_ns_usages_hist'] = nsUsagesHist
      } else {
        state.reportEditData[patientIndex]['last_report_id'] = null
        state.reportEditData[patientIndex]['report_hist'] = null
        state.reportEditData[patientIndex]['report_hist_count'] = 0
        state.reportEditData[patientIndex]['report_hist_no'] = 0
        state.reportEditData[patientIndex]['report_ns_usages_hist'] = null
      }
      // 通知なし
    },

    /** 定型文検索 */
    [NSIPS_REPORT_EDIT_SEARCH_PHRASE_FAILURE] (state, data) {
      console.log('NSIPS_REPORT_EDIT_SEARCH_PHRASE_FAILURE')
      // 通知
      state.reportEditNotify = {
        danger: true,
        message_i18n: 'messages.search.danger'
      }
      setTimeout(() => {
        state.reportEditNotify = null
      }, constant.notifyShowTime.normal)
    },
    /** 定型文検索 */
    [NSIPS_REPORT_EDIT_SEARCH_PHRASE_SUCCESS] (state, params) {
      console.log('NSIPS_REPORT_EDIT_SEARCH_PHRASE_SUCCESS')
      var data = params.data
      var callback = params.callback
      // 通知なし
      state.reportEditPhrases = data['data']['phrases']
      callback()
    },

    /** 補助入力失敗 */
    [NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS_FAILURE] (state, data) {
      console.log('NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS_FAILURE')
      // 通知
      state.reportEditNotify = {
        danger: true,
        message_i18n: 'messages.search.danger'
      }
      setTimeout(() => {
        state.reportEditNotify = null
      }, constant.notifyShowTime.normal)
    },
    /** 補助入力成功 */
    [NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS_SUCCESS] (state, params) {
      console.log('NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS_SUCCESS')
      var data = params.data
      if ('data' in data && data.data !== null) {
        var consultPointList = data.data['consult_point_list']
        for (var i = 0; i < consultPointList.length; i++) {
          var patientIndex = consultPointList[i]['patient_index']
          var txt1 = consultPointList[i]['consult_point1']
          var txt2 = consultPointList[i]['consult_point2']
          // 指導内容
          if (utils.isBlank(state.reportEditData[patientIndex]['report']['soap_comment'])) {
            state.reportEditData[patientIndex]['report']['soap_comment'] = txt1 + '\n' + txt2
          }
        }
      }
      // 通知なし
    },

    /** 介護支援事業所情報取得 */
    [NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO_FAILURE] (state, params) {
      console.log('NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO_FAILURE')
      // 通知
      state.reportEditNotify = {
        danger: true,
        message_i18n: 'messages.search.danger'
      }
      setTimeout(() => {
        state.reportEditNotify = null
      }, constant.notifyShowTime.normal)
      if (params.callback) {
        params.callback(null)
      }
    },
    /** 介護支援事業所情報取得 */
    [NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO_SUCCESS] (state, params) {
      console.log('NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO_SUCCESS')
      var data = params.data.data
      // 通知なし
      if (params.callback) {
        params.callback(data)
      }
    },

    /** 医療機関情報取得 */
    [NSIPS_REPORT_EDIT_CLINIC_SEND_INFO_FAILURE] (state, params) {
      console.log('NSIPS_REPORT_EDIT_CLINIC_SEND_INFO_FAILURE')
      // 通知
      state.reportEditNotify = {
        danger: true,
        message_i18n: 'messages.search.danger'
      }
      setTimeout(() => {
        state.reportEditNotify = null
      }, constant.notifyShowTime.normal)
      if (params.callback) {
        params.callback(null)
      }
    },
    /** 医療機関情報取得 */
    [NSIPS_REPORT_EDIT_CLINIC_SEND_INFO_SUCCESS] (state, params) {
      console.log('NSIPS_REPORT_EDIT_CLINIC_SEND_INFO_SUCCESS')
      var data = params.data.data
      // 通知なし
      if (params.callback) {
        params.callback(data)
      }
    },

    /** 報告書削除 */
    [NSIPS_REPORT_EDIT_REPORT_DELETE_NEW_REPORT] (state, params) {
      console.log('NSIPS_REPORT_EDIT_REPORT_DELETE_NEW_REPORT')
      // 通知
      state.reportEditNotify = {
        success: true,
        message_i18n: 'messages.delete.success_report_delete'
      }
      setTimeout(() => {
        state.reportEditNotify = null
      }, constant.notifyShowTime.normal)

      // 現在の患者選択インデックスが少ない場合
      if (state.reportEditTotalCount <= 1) {
        params.callback(true)
      } else {
        state.reportEditTotalCount -= 1
        state.reportEditData.splice(params.patientIndex, 1)
        state.reportEditDataBackup.splice(params.patientIndex, 1)
        state.prescriptionsDeliveryDates.splice(params.patientIndex, 1)
        params.callback(false)
      }
    },

    /** メッセージ表示用 */
    [NSIPS_REPORT_EDIT_MSG_ALERT] (state, params) {
      console.log('NSIPS_REPORT_EDIT_MSG_ALERT')
      // 通知
      state.reportEditNotify = params
      setTimeout(() => {
        state.reportEditNotify = null
      }, constant.notifyShowTime.normal)
    },

    [NSIPS_SEARCH_SUCCESS] (state, params) {
      console.log('NSIPS_SEARCH_SUCCESS')
      state.nsipsDate = params.data.data
      if (params.callback) {
        params.callback()
      }
    },

    [NSIPS_SEARCH_FAILURE] (state, data) {
      console.log('NSIPS_SEARCH_FAILURE')
    },

    [NSIPS_DELIVERY_DATE_SUCCESS] (state, params) {
      console.log('NSIPS_DELIVERY_DATE_SUCCESS')
      state.prescriptionsDeliveryDate = params.data.data
      if (params.callback) {
        params.callback()
      }
    },

    [NSIPS_DELIVERY_DATE_FAILURE] (state, data) {
      console.log('NSIPS_DELIVERY_DATE_FAILURE')
    },

    [NSIPS_PRESCRIPTION_COMPARISON_SUCCESS] (state, params) {
      console.log('NSIPS_PRESCRIPTION_COMPARISON_SUCCESS')
      var data = params.data.data
      if (params.callback) {
        params.callback(data)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/nsips-report-edit.js